import { Keyboard } from '@capacitor/keyboard';

import { KEYBOARD_OPEN_CLASS } from './native.constants';

// Reflect the native software keyboard's visibility as a class on <html>, so the login layout can
// react to it deterministically (compact + top-align the card) instead of guessing from viewport
// height — a guess that fails when the keyboard-shrunk WebView is still taller than a fixed px
// threshold. Native-only by construction: the Capacitor Keyboard plugin only emits these events
// inside the native shell, so the web build is never affected.
export const installKeyboardVisibilityClass = () => {
  const setOpen = isOpen => {
    document.documentElement.classList.toggle(KEYBOARD_OPEN_CLASS, isOpen);
  };

  Keyboard.addListener('keyboardWillShow', () => setOpen(true));
  Keyboard.addListener('keyboardWillHide', () => setOpen(false));
};
